export default __webpack_public_path__ + "static/media/4.202f7ed0.png";